// eslint-disable-next-line import/prefer-default-export
export const validationMixin = {
    methods: {
        invalidClass(validator) {
            return (validator && validator.$dirty && validator.$error) ? 'is-invalid' : null;
        },
    },
};
